import Env from '../base/env'
import raf from 'raf'

export default class Fx
{
    constructor(view)
    {
        this.view = view
        this.$appearReady = this.view.querySelector('.jsReady--appearReveal')
        this.$galleryItems = this.view.querySelectorAll('.jsParallax--item')
        this.$parallaxItems = this.view.querySelectorAll('.jsParallaxV--item')
        this.$scrollScaleItems = this.view.querySelectorAll('.jsScroll--scale')
        this.raf = undefined
        this.position = undefined
        this.setup()
        if(this.$galleryItems.length > 0 || this.$parallaxItems.length > 0)
        {
            this.watcher()
        }
    }

    actions()
    {
        if(Env.mobileCSS === false) {
            this.parallaxVerticalInner()
            this.parallaxVertical()
            this.scrollScale()
        }
    }

    destroy()
    {
        raf.cancel(this.raf)
    }

    parallaxVertical()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const scroll = this.position

        for(let i = 0; i < this.$parallaxItems.length; i++) {
            const $item = this.$parallaxItems[i]
            const getPosY = $item.getAttribute('data-y') * 1
            const getCurrentY = (typeof $item._gsTransform != "undefined")?$item._gsTransform.y:0
            const ratio = ((($item.getBoundingClientRect().top - getCurrentY) + ($item.getBoundingClientRect().height / 2)) / (viewport.height / 2) - 1)
            const newPosY = ratio * getPosY

            TweenLite.set($item , { y : newPosY })

            // Waypoint
            if(typeof $item.dataset.waypoint === "undefined" && $item.classList.contains('can--show') === false && ratio <= 1.5) {
                $item.classList.add('can--show')
                $item.dataset.waypoint = true
            }
        }
    }

    parallaxVerticalInner()
    {
        const viewport = Env.framework.toolbox.getViewport().height
        for(let i = 0; i < this.$galleryItems.length; i++){
            const $item = this.$galleryItems[i]
            const getRate = $item.getAttribute('data-rate') * 1 || 8
            const getMove = $item.getAttribute('data-move') * 1 || 100
            const getHeight = $item.getBoundingClientRect().height
            const $visual = $item.querySelector('.bg')
            const progress = ($item.getBoundingClientRect().y + getHeight) / (viewport + getHeight)
            const newYPos = progress * -getMove

            if(Env.phone == false && Env.tablet == false && Env.ie11 == false && Env.edge == false)
            {
                let currentYPos = Env.framework.toolbox.getTransformValues($visual).y
                currentYPos += (newYPos - currentYPos) / getRate

                TweenLite.set($visual , { y : currentYPos })
            }
            if(Env.ie11 == true || Env.edge == true)
            {
                if($item.classList.contains('cancel--anim') == false)
                {
                    $item.classList.add('cancel--anim')
                }
            }
        }
    }

    scrollScale()
    {
        const viewport = Env.framework.toolbox.getViewport().height
        for(let i = 0; i < this.$scrollScaleItems.length; i++){
            const $item = this.$scrollScaleItems[i]
            const getHeight = $item.getBoundingClientRect().height
            const $visual = $item.querySelector('.bg')
            const progress = ($item.getBoundingClientRect().y) /  getHeight
            const ratioScale = .3 * progress
            let newScale = 1 + ratioScale

            if(newScale > 1.5) {
                newScale = 1.5
            } else if(newScale < 1) {
                newScale = 1
            }

            if(Env.phone == false && Env.tablet == false && Env.ie11 == false && Env.edge == false)
            {
                let currentX
                if(typeof  $item._gsTransform != 'undefined') {
                    currentX = $item._gsTransform.scaleX
                } else {
                    currentX = 1
                }
                currentX += (newScale - currentX) / 8
                TweenLite.set($item , { scale : currentX })
            }

        }
    }

    setup()
    {
        if(this.$appearReady != null) {
            const timing = (Env.isVisiting == true)?0:2800
            setTimeout(()=> {
                this.$appearReady.classList.add('is--shown')
            }, timing);
        }
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })
        this.position = Env.framework.toolbox.scrollPosition()
        this.actions()
    }
}